/**
 * Sets the document's title.
 * @param title Title.
 */
export const setTitle = (title) => {
    document.title = title;
};
